
function _resizeDataURL (dataURI, ratio) {
  return new Promise((resolve) => {
    // We create an image to receive the Data URI
    const img = document.createElement('img')

    // When the event "onload" is triggered we can resize the image.
    img.onload = function () {
      // We create a canvas and get its context.
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const wantedWidth = this.naturalWidth * ratio
      const wantedHeight = this.naturalHeight * ratio

      // We set the dimensions at the wanted size.
      canvas.width = wantedWidth
      canvas.height = wantedHeight

      // We resize the image with the canvas method drawImage();
      ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight)
      const dataURI = canvas.toDataURL()

      // This is the return of the Promise
      resolve(dataURI)
    }
    img.onload.bind(img)

    // We put the Data URI in the image's src attribute => this will trigger onload
    img.src = dataURI
  })
}

const MIN_RATIO = 0.5
const THRESHOLD = 0.1

export function _adjustRatio (originalRatio, minRatio = MIN_RATIO, threshold = THRESHOLD) {
  let ratio = 1 / originalRatio // VideoElement's ratio is > 1
  ratio = Math.max(ratio, minRatio)
  if (Math.abs(1 - ratio) <= threshold) {
    ratio = 1
  }

  return ratio
}

export function assembleCSSStyleDeclaration (dataURI, hotspotX, hotspotY) {
  return `url('${dataURI}') ${hotspotX} ${hotspotY}, default`
}

export function assembleDataURI (imageByteArray) {
  return `data:image/bmp;base64, ${imageByteArray}`
}

function createDeps () {
  return {
    resizeDataURL: _resizeDataURL,
    adjustRatio: _adjustRatio,
    assembleCSSStyleDeclaration: assembleCSSStyleDeclaration
  }
}

const defaultDeps = createDeps()

export async function scaleMouseCursor (cursor, videoElementRatio, deps = defaultDeps) {
  if (!cursor.cursorImage) {
    throw new Error()
  }
  const { resizeDataURL, adjustRatio, assembleCSSStyleDeclaration } = deps
  const originalDataURI = assembleDataURI(cursor.cursorImage)

  const ratio = adjustRatio(videoElementRatio)

  // base64 byte array of the image
  const dataURI = (ratio === 1)
    ? originalDataURI
    : await resizeDataURL(originalDataURI, ratio, ratio)

  const scaledMousePointer = assembleCSSStyleDeclaration(dataURI, cursor.hotspotX * ratio, cursor.hotspotY * ratio)
  return scaledMousePointer
}
